import { ID, newTaskSuffix } from '@griply/types';

export const filterNewTaskChildIds = (children: ID[] | undefined): ID[] =>
  children ? children.filter((id) => !id.endsWith(newTaskSuffix)) : [];
